import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  searchTerm: '',
};

const searchBoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.SEARCHBOX_SET_TERMS:
      return {
        ...state,
        searchTerm: action.payload.searchTerm,
      };
    default:
      return state;
  }
};

export default searchBoxReducer;
